import { render, staticRenderFns } from "./GrowingTextField.vue?vue&type=template&id=4050c886&scoped=true&"
import script from "./GrowingTextField.vue?vue&type=script&lang=js&"
export * from "./GrowingTextField.vue?vue&type=script&lang=js&"
import style0 from "./GrowingTextField.vue?vue&type=style&index=0&id=4050c886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4050c886",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
